/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** @format int32 */
export enum DateTimeQueryOptions {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value4 = 4,
}

export enum DateTimeDataTypeMode {
  DateTime = "DateTime",
  DateOnly = "DateOnly",
  TimeOnly = "TimeOnly",
}

export interface AuthenticateModel {
  /** @minLength 1 */
  username: string;
  /** @minLength 1 */
  password: string;
}

export interface AuthenticateResult {
  username?: string | null;
  token?: string | null;
}

export interface BoundingBox {
  /** @format int32 */
  x?: number;
  /** @format int32 */
  y?: number;
  /** @format int32 */
  width?: number;
  /** @format int32 */
  height?: number;
}

export interface DetectedFaceInfo {
  faceId?: string | null;
  detectId?: string | null;
  /** @format float */
  confidence?: number;
  /** @format float */
  faceQuality?: number;
  boundingBox?: BoundingBox;
}

export interface EdgePerson {
  faceId?: string | null;
  /** @format uuid */
  personId?: string;
  firstName?: string | null;
  lastName?: string | null;
  tags?: EdgeTag[] | null;
}

export interface EdgeTag {
  name?: string | null;
}

export interface FaceBoundingBox {
  /** @format int32 */
  x?: number;
  /** @format int32 */
  y?: number;
  /** @format int32 */
  width?: number;
  /** @format int32 */
  height?: number;
}

export interface FaceCompareRequest {
  /** @format byte */
  image1?: string | null;
  /** @format byte */
  image2?: string | null;
}

export interface FaceCompareResponse {
  match?: boolean;
  /** @format float */
  confidence?: number;
}

export interface FaceDetectRequest {
  /** @format byte */
  image?: string | null;
}

export interface FaceDetected {
  faceId?: string | null;
  /** @format uuid */
  personId?: string | null;
  /** @format double */
  confidence?: number | null;
  /** @format double */
  quality?: number;
  boundingBox?: FaceBoundingBox;
}

export interface FaceDetectionItem {
  /** @format double */
  confidence?: number;
  /** @format date-time */
  dateTimeUtc?: string;
  timeZone?: string | null;
  detector?: string | null;
  /** @format byte */
  image?: string | null;
}

export interface FaceEdgePublishResponse {
  detectedFaces?: DetectedFaceInfo[] | null;
}

export interface FaceEdgeRecognize {
  /** @format byte */
  croppedAligned?: string | null;
  /** @format byte */
  expanded?: string | null;
  embeddings?: number[] | null;
  recognitionModel?: string | null;
  /** @format date-time */
  detectTimeUtc: string;
  /** @minLength 1 */
  ianaTimeZone: string;
  /** @minLength 1 */
  detectorName: string;
}

export interface FaceEdgeRecognizeWithOptions {
  /** @format byte */
  croppedAligned?: string | null;
  /** @format byte */
  expanded?: string | null;
  embeddings?: number[] | null;
  recognitionModel?: string | null;
  /** @format date-time */
  detectTimeUtc: string;
  /** @minLength 1 */
  ianaTimeZone: string;
  /** @minLength 1 */
  detectorName: string;
  largestFaceOnly?: boolean;
  allowDoubleDetection?: boolean;
}

export interface FaceEnrollRequest {
  /** @format byte */
  faceImage?: string | null;
}

export interface FaceEnrollResponse {
  /** @format uuid */
  personId?: string;
}

export interface FacesDetected {
  detections?: FaceDetected[] | null;
}

export interface IdentityAddressItem {
  /** @format uuid */
  personAddressId?: string | null;
  street?: string | null;
  street2?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
  country?: string | null;
}

export interface IdentityAliasItem {
  /** @format uuid */
  personAliasId?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  middleName?: string | null;
  title?: string | null;
}

export interface IdentityEntityFieldItem {
  /** @format uuid */
  entityFieldId?: string | null;
  name?: string | null;
  stringValue?: string | null;
  /** @format date-time */
  dateValue?: string | null;
  /** @format double */
  numberValue?: number | null;
  boolValue?: boolean | null;
}

export interface IdentityEntityFieldSettingDateTimeResponseItem {
  fieldId?: string | null;
  name?: string | null;
  description?: string | null;
  category?: string | null;
  mode?: DateTimeDataTypeMode;
  queryOptions?: DateTimeQueryOptions[] | null;
}

export interface IdentityEntityFieldSettingStringItem {
  name?: string | null;
  description?: string | null;
  category?: string | null;
}

export interface IdentityEntityFieldSettingStringResponseItem {
  fieldId?: string | null;
  name?: string | null;
  description?: string | null;
  category?: string | null;
}

export interface IdentityEntityFieldSettingsDateTimeItem {
  name?: string | null;
  description?: string | null;
  category?: string | null;
  mode?: DateTimeDataTypeMode;
  queryOptions?: DateTimeQueryOptions[] | null;
}

export interface IdentityPersonItem {
  /** @format uuid */
  personId?: string;
  aliases?: IdentityAliasItem[] | null;
  addresses?: IdentityAddressItem[] | null;
  entityFields?: IdentityEntityFieldItem[] | null;
  tags?: IdentityPersonTagItem[] | null;
  notes?: IdentityPersonNoteItem[] | null;
}

export interface IdentityPersonNoteItem {
  /** @format uuid */
  noteId?: string | null;
  summary?: string | null;
  body?: string | null;
  author?: string | null;
  /** @format uuid */
  sharedId?: string | null;
}

export interface IdentityPersonTagItem {
  /** @format uuid */
  tagId?: string;
  /** @format date-time */
  expires?: string | null;
  /** @format date-time */
  created?: string;
}

export interface IdentityTagItem {
  /** @format uuid */
  tagId?: string | null;
  tagName?: string | null;
  disabled?: boolean;
  description?: string | null;
  defaultExpirePeriod?: string;
}

export interface JwtAppSettingsItem {
  enableJwtAuth: boolean;
}

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}

export interface PublicAuthInfo {
  /** @minLength 1 */
  authHost: string;
  /** @minLength 1 */
  callback: string;
  /** @minLength 1 */
  clientId: string;
  /** @minLength 1 */
  portalUri: string;
}

export interface PwItem {
  password?: string | null;
}

export interface SessionProfile {
  /** @minLength 1 */
  email: string;
  /** @format date-time */
  expires: string;
  /** @minLength 1 */
  givenName: string;
  roles: string[];
  /** @minLength 1 */
  token: string;
  /** @minLength 1 */
  userId: string;
  /** @minLength 1 */
  username: string;
}

export interface SessionStartRecord {
  refreshToken?: string | null;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data.data;
    });
  };
}

/**
 * @title eConnect.Identities.Server
 * @version v1
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  auth = {
    /**
     * No description
     *
     * @tags AuthSettings
     * @name GetJwtSettingsAsync
     * @request GET:/auth/v1/settings/jwt
     * @secure
     */
    getJwtSettingsAsync: (params: RequestParams = {}) =>
      this.request<JwtAppSettingsItem, ProblemDetails>({
        path: `/auth/v1/settings/jwt`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AuthSettings
     * @name SetJwtSettingsAsync
     * @request POST:/auth/v1/settings/jwt
     * @secure
     */
    setJwtSettingsAsync: (
      data: JwtAppSettingsItem,
      params: RequestParams = {},
    ) =>
      this.request<void, ProblemDetails>({
        path: `/auth/v1/settings/jwt`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mobile
     * @name Ping
     * @request GET:/auth/v1/mobile/ping
     * @secure
     */
    ping: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/auth/v1/mobile/ping`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mobile
     * @name SessionEnd
     * @request GET:/auth/v1/mobile/session-end
     * @secure
     */
    sessionEnd: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/auth/v1/mobile/session-end`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mobile
     * @name SessionStart
     * @request POST:/auth/v1/mobile/session-start
     * @secure
     */
    sessionStart: (data: SessionStartRecord, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/auth/v1/mobile/session-start`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name GetAuthInfoAsync
     * @request GET:/auth/v1/user/authinfo
     * @secure
     */
    getAuthInfoAsync: (params: RequestParams = {}) =>
      this.request<PublicAuthInfo, ProblemDetails | void>({
        path: `/auth/v1/user/authinfo`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name GetProfileAsync
     * @request GET:/auth/v1/user/profile
     * @secure
     */
    getProfileAsync: (params: RequestParams = {}) =>
      this.request<SessionProfile, ProblemDetails>({
        path: `/auth/v1/user/profile`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name Login
     * @request GET:/auth/v1/user/login
     * @secure
     */
    login: (
      query?: {
        next?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ProblemDetails>({
        path: `/auth/v1/user/login`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name Logout
     * @request GET:/auth/v1/user/logout
     * @secure
     */
    logout: (params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/auth/v1/user/logout`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
  api = {
    /**
     * No description
     *
     * @tags EntityFieldSettings
     * @name EntityFieldSettingUpsertStringField
     * @request PUT:/api/v1/EntityFieldSettings/{entityType}/stringField/{fieldId}
     * @secure
     */
    entityFieldSettingUpsertStringField: (
      entityType: string,
      fieldId: string,
      data: IdentityEntityFieldSettingStringItem,
      params: RequestParams = {},
    ) =>
      this.request<IdentityEntityFieldSettingStringResponseItem, any>({
        path: `/api/v1/EntityFieldSettings/${entityType}/stringField/${fieldId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags EntityFieldSettings
     * @name EntityFieldSettingUpsertDateTimeField
     * @request PUT:/api/v1/EntityFieldSettings/{entityType}/datetimeField/{fieldId}
     * @secure
     */
    entityFieldSettingUpsertDateTimeField: (
      entityType: string,
      fieldId: string,
      data: IdentityEntityFieldSettingsDateTimeItem,
      params: RequestParams = {},
    ) =>
      this.request<IdentityEntityFieldSettingDateTimeResponseItem, any>({
        path: `/api/v1/EntityFieldSettings/${entityType}/datetimeField/${fieldId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FaceDetections
     * @name FillFaceEvents
     * @request GET:/api/v1/people/detections/backfill
     * @secure
     */
    fillFaceEvents: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/people/detections/backfill`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FaceDetections
     * @name GetDetectionsQueryByFaceId
     * @request GET:/api/v1/people/detections/faceId/{faceId}
     * @secure
     */
    getDetectionsQueryByFaceId: (
      faceId: string,
      query?: {
        /**
         * @format int32
         * @default 0
         */
        skip?: number;
        /**
         * @format int32
         * @default 10
         */
        take?: number;
        /** @format int32 */
        epochStartMs?: number;
        /** @format int32 */
        epochEndMs?: number;
        /** @default true */
        dateAscending?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<FaceDetectionItem[], any>({
        path: `/api/v1/people/detections/faceId/${faceId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FaceDetections
     * @name GetDetectionsQueryByPersonId
     * @request GET:/api/v1/people/detections/personId/{personId}
     * @secure
     */
    getDetectionsQueryByPersonId: (
      personId: string,
      query?: {
        /**
         * @format int32
         * @default 0
         */
        skip?: number;
        /**
         * @format int32
         * @default 10
         */
        take?: number;
        /** @format int32 */
        epochStartMs?: number;
        /** @format int32 */
        epochEndMs?: number;
        /** @default true */
        dateAscending?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<FaceDetectionItem[], any>({
        path: `/api/v1/people/detections/personId/${personId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FaceEdge
     * @name FaceEdgePublish
     * @request POST:/api/v1/faceEdge/publish
     * @secure
     */
    faceEdgePublish: (data: FaceEdgeRecognize, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/faceEdge/publish`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FaceEdge
     * @name FaceEdgeLookup
     * @request POST:/api/v1/faceEdge/lookup
     * @secure
     */
    faceEdgeLookup: (
      data: {
        /** @format binary */
        CroppedAligned?: File;
        /** @format binary */
        Embeddings?: File;
        RecognitionModel?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<EdgePerson, any>({
        path: `/api/v1/faceEdge/lookup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FaceEdge
     * @name FaceEdgeRecognizeLookup
     * @request POST:/api/v1/faceEdge/recognize
     * @secure
     */
    faceEdgeRecognizeLookup: (
      data: FaceEdgeRecognize,
      params: RequestParams = {},
    ) =>
      this.request<EdgePerson, any>({
        path: `/api/v1/faceEdge/recognize`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FaceEdge
     * @name FaceEdgePublishWithResponse
     * @request POST:/api/v1/faceEdge/publishWithResponse
     * @secure
     */
    faceEdgePublishWithResponse: (
      data: FaceEdgeRecognizeWithOptions,
      params: RequestParams = {},
    ) =>
      this.request<FaceEdgePublishResponse, any>({
        path: `/api/v1/faceEdge/publishWithResponse`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FaceRec
     * @name FaceDetect
     * @request POST:/api/v1/faces/faceDetect
     * @secure
     */
    faceDetect: (data: FaceDetectRequest, params: RequestParams = {}) =>
      this.request<FacesDetected, any>({
        path: `/api/v1/faces/faceDetect`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FaceRec
     * @name FaceEnroll
     * @request POST:/api/v1/faces/faceEnroll
     * @secure
     */
    faceEnroll: (
      data: FaceEnrollRequest,
      query?: {
        /** @format uuid */
        personId?: string;
        /** @default false */
        forceEnrollment?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<FaceEnrollResponse, any>({
        path: `/api/v1/faces/faceEnroll`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FaceRec
     * @name FaceCompare
     * @request POST:/api/v1/faces/faceCompare
     * @secure
     */
    faceCompare: (data: FaceCompareRequest, params: RequestParams = {}) =>
      this.request<FaceCompareResponse, any>({
        path: `/api/v1/faces/faceCompare`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags People
     * @name GetEnrollmentPhoto
     * @request GET:/api/v1/people/enrollmentPhoto/{faceId}
     * @secure
     */
    getEnrollmentPhoto: (faceId: string, params: RequestParams = {}) =>
      this.request<string, string>({
        path: `/api/v1/people/enrollmentPhoto/${faceId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags People
     * @name GetDetectionPhoto
     * @request GET:/api/v1/people/detectionPhoto/{faceId}/{detectionId}
     * @secure
     */
    getDetectionPhoto: (
      faceId: string,
      detectionId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/people/detectionPhoto/${faceId}/${detectionId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags People
     * @name GetFileDocumentData
     * @request GET:/api/v1/people/{personId}/fileDocuments/{documentId}/data
     * @secure
     */
    getFileDocumentData: (
      personId: string,
      documentId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/people/${personId}/fileDocuments/${documentId}/data`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags People
     * @name UploadFileDocument
     * @request POST:/api/v1/people/fileDocuments/upload
     * @secure
     */
    uploadFileDocument: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/people/fileDocuments/upload`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags People
     * @name GetPerson
     * @request GET:/api/v1/people/{personId}
     * @secure
     */
    getPerson: (personId: string, params: RequestParams = {}) =>
      this.request<IdentityPersonItem, any>({
        path: `/api/v1/people/${personId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags People
     * @name GetPersonByEntityField
     * @request GET:/api/v1/people/entityField/{fieldName}/entityValue/{fieldValue}
     * @secure
     */
    getPersonByEntityField: (
      fieldName: string,
      fieldValue: string,
      params: RequestParams = {},
    ) =>
      this.request<IdentityPersonItem[], any>({
        path: `/api/v1/people/entityField/${fieldName}/entityValue/${fieldValue}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags People
     * @name QueryPeople
     * @request GET:/api/v1/people
     * @secure
     */
    queryPeople: (
      query?: {
        /** @format uuid */
        tagId?: string;
        entityFieldName?: string;
        entityFieldStringValue?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<IdentityPersonItem[], any>({
        path: `/api/v1/people`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags People
     * @name GetPersonEntityFields
     * @request GET:/api/v1/people/{personId}/entityFields
     * @secure
     */
    getPersonEntityFields: (
      personId: string,
      query?: {
        fieldName?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<IdentityEntityFieldItem[], any>({
        path: `/api/v1/people/${personId}/entityFields`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags People
     * @name UpsertPersonEntityField
     * @request PUT:/api/v1/people/{personId}/entityFields
     * @secure
     */
    upsertPersonEntityField: (
      personId: string,
      data: IdentityEntityFieldItem,
      params: RequestParams = {},
    ) =>
      this.request<IdentityEntityFieldItem, any>({
        path: `/api/v1/people/${personId}/entityFields`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags People
     * @name DeletePersonEntityField
     * @request DELETE:/api/v1/people/{personId}/entityFields/{entityId}
     * @secure
     */
    deletePersonEntityField: (
      personId: string,
      entityId: string,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/people/${personId}/entityFields/${entityId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags People
     * @name GetPersonTags
     * @request GET:/api/v1/people/{personId}/tags
     * @secure
     */
    getPersonTags: (
      personId: string,
      query?: {
        tagName?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<IdentityPersonTagItem[], any>({
        path: `/api/v1/people/${personId}/tags`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags People
     * @name UpsertPersonTag
     * @request PUT:/api/v1/people/{personId}/tags
     * @secure
     */
    upsertPersonTag: (
      personId: string,
      data: IdentityPersonTagItem,
      params: RequestParams = {},
    ) =>
      this.request<IdentityPersonTagItem, any>({
        path: `/api/v1/people/${personId}/tags`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags People
     * @name DeletePersonTag
     * @request DELETE:/api/v1/people/{personId}/tags/{entityId}
     * @secure
     */
    deletePersonTag: (
      personId: string,
      entityId: string,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/people/${personId}/tags/${entityId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags People
     * @name GetPersonAliases
     * @request GET:/api/v1/people/{personId}/aliases
     * @secure
     */
    getPersonAliases: (personId: string, params: RequestParams = {}) =>
      this.request<IdentityAliasItem[], any>({
        path: `/api/v1/people/${personId}/aliases`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags People
     * @name UpsertPersonAlias
     * @request PUT:/api/v1/people/{personId}/aliases
     * @secure
     */
    upsertPersonAlias: (
      personId: string,
      data: IdentityAliasItem,
      params: RequestParams = {},
    ) =>
      this.request<IdentityAliasItem, any>({
        path: `/api/v1/people/${personId}/aliases`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags People
     * @name UpsertPersonAddress
     * @request PUT:/api/v1/people/{personId}/addresses
     * @secure
     */
    upsertPersonAddress: (
      personId: string,
      data: IdentityAddressItem,
      params: RequestParams = {},
    ) =>
      this.request<IdentityAddressItem, any>({
        path: `/api/v1/people/${personId}/addresses`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags People
     * @name DeletePersonAlias
     * @request DELETE:/api/v1/people/{personId}/aliases/{entityId}
     * @secure
     */
    deletePersonAlias: (
      personId: string,
      entityId: string,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/people/${personId}/aliases/${entityId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags People
     * @name GetPersonNotes
     * @request GET:/api/v1/people/{personId}/notes
     * @secure
     */
    getPersonNotes: (personId: string, params: RequestParams = {}) =>
      this.request<IdentityPersonNoteItem[], any>({
        path: `/api/v1/people/${personId}/notes`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags People
     * @name UpsertPersonNotes
     * @request PUT:/api/v1/people/{personId}/notes
     * @secure
     */
    upsertPersonNotes: (
      personId: string,
      data: IdentityPersonNoteItem,
      params: RequestParams = {},
    ) =>
      this.request<IdentityPersonNoteItem, any>({
        path: `/api/v1/people/${personId}/notes`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags People
     * @name DeletePersonNotes
     * @request DELETE:/api/v1/people/{personId}/notes/{entityId}
     * @secure
     */
    deletePersonNotes: (
      personId: string,
      entityId: string,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/people/${personId}/notes/${entityId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tags
     * @name GetTags
     * @request GET:/api/v1/Tags
     * @secure
     */
    getTags: (
      query?: {
        tagName?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<IdentityTagItem[], any>({
        path: `/api/v1/Tags`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tags
     * @name AddTag
     * @request POST:/api/v1/Tags
     * @secure
     */
    addTag: (data: IdentityTagItem, params: RequestParams = {}) =>
      this.request<IdentityTagItem, any>({
        path: `/api/v1/Tags`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tags
     * @name GetTag
     * @request GET:/api/v1/Tags/{tagId}
     * @secure
     */
    getTag: (tagId: string, params: RequestParams = {}) =>
      this.request<IdentityTagItem, any>({
        path: `/api/v1/Tags/${tagId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tags
     * @name UpdateTag
     * @request PUT:/api/v1/Tags/{tagId}
     * @secure
     */
    updateTag: (
      tagId: string,
      data: IdentityTagItem,
      params: RequestParams = {},
    ) =>
      this.request<IdentityTagItem, any>({
        path: `/api/v1/Tags/${tagId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tags
     * @name DeleteTag
     * @request DELETE:/api/v1/Tags/{tagId}
     * @secure
     */
    deleteTag: (tagId: string, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/Tags/${tagId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Test
     * @name TestBuilder
     * @request GET:/api/v1/people/testBuilder
     * @secure
     */
    testBuilder: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/people/testBuilder`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name RenewToken
     * @request GET:/api/v1/renewToken
     * @secure
     */
    renewToken: (params: RequestParams = {}) =>
      this.request<AuthenticateResult, any>({
        path: `/api/v1/renewToken`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name Authenticate
     * @request POST:/api/v1/authenticate
     * @secure
     */
    authenticate: (data: AuthenticateModel, params: RequestParams = {}) =>
      this.request<AuthenticateResult, any>({
        path: `/api/v1/authenticate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name Gc
     * @request GET:/api/v1/gc
     * @secure
     */
    gc: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/gc`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name SetUserPassword
     * @request POST:/api/v1/setPassword/{username}
     * @secure
     */
    setUserPassword: (
      username: string,
      data: PwItem,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/setPassword/${username}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
}
